import React, { useEffect, useState, useRef } from "react";
import localforage from "localforage";

// automatically adds prefix
localforage.config({
  name: "codedraken",
});

export const useLocalForage: (
  key: "notepad" | "savedLinks",
  initalValue: any,
  delay?: number
) => [any, React.Dispatch<any>] = (key, initialValue, delay) => {
  const [storedValue, setStoredvalue] = useState(initialValue);
  const storageRef = useRef(initialValue);

  const initialLoad = async () => {
    try {
      const item: any = await localforage.getItem(key);

      if (item !== null) {
        storageRef.current = item;
        return setStoredvalue(item);
      }
      // nothing in local storage
      setValue(initialValue);
    } catch (e) {
      console.log(e);
    }
  };

  // using an effect for initial state because its async
  useEffect(() => {
    initialLoad();
  }, []);

  // on value change
  useEffect(() => {
    if (storageRef.current === storedValue) return;

    if (!delay) {
      localforage.setItem(key, storedValue);
    } else {
      const timeout = setTimeout(() => {
        localforage.setItem(key, storedValue);
      }, delay);

      return () => clearTimeout(timeout);
    }

    storageRef.current = storedValue;
  }, [key, storedValue, delay]);

  // wrapped version of setStoredvalue
  const setValue = value => {
    try {
      const valueToStore = value instanceof Function ? value() : value;

      setStoredvalue(valueToStore);
    } catch (e) {
      console.log(e);
    }
  };

  return [storedValue, setValue];
};

export default useLocalForage;
